import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import { roleMS } from '../../../models/roleMS.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { ApplicationService } from '../../../services/application/applications.service';
import { AuthService } from '../../../services/user/auth.service';
import { RoleMSService } from '../../../services/utils/roleMS.service';

@Component({
  selector: 'app-rolesapplication-form',
  providers: [],
  templateUrl: './rolesApplicationForm.component.html',
  styles: ['label.required:after {top: 0}']
  })

export class RolesApplicationFormComponent implements OnChanges, OnInit {

  @Input() role: roleMS;
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  applicationDropdown: SelectItem[];
  addRoleForm: FormGroup;
  labelButton: string;
  showdropdown = false;
  invalidSubmit: boolean;
  validation: any;

  constructor(
    private fb: FormBuilder,
    private srvAuth: AuthService,
    private srvRoleMS: RoleMSService,
    private srvDataTable: DataTableService,
    private srvApplication: ApplicationService

  ) {
    this.applicationDropdown = [{
      value: '',
      label: ''
    }];
    const loggedUser = this.srvAuth.user;
    if (loggedUser.role === 'S') {
      this.srvApplication.getAll().subscribe( res =>
        res.forEach( app => {
          this.applicationDropdown.push({
            value: app.id,
            label: app.name
          });
        }))
    } else {
      this.srvAuth.user.enabledUserApps.forEach((userApp) => {
        const item: SelectItem = {
          value: userApp.application_id,
          label: userApp.application_name
        };
        this.applicationDropdown.push(item);
      });
    }
  }

  ngOnInit() {
    this.loadValidation();
  }
  loadValidation() {
    this.srvRoleMS.getFields().subscribe(res => {
      this.validation = res;
    });
  }
  private createRoleForm(role: roleMS): FormGroup {
    return this.fb.group({
      'descr': new FormControl(role != null ? this.role.description : ''),
      'type' : new FormControl(role != null ? this.role.applicationId : '')
    });
  }

  ngOnChanges(changes): void {

    const currentRole: roleMS = changes['role'].currentValue;
    if (currentRole != null) {
      this.addRoleForm = this.createRoleForm(currentRole);
      this.labelButton = 'roleMS.btnUpdate';
        this.showdropdown = false;
    } else if (changes['role'].previousValue === undefined) {
      this.addRoleForm = this.createRoleForm(null);
      this.labelButton = 'roleMS.btnCreate';
      this.showdropdown = true;
    }
  }

  addRole(): void {

    if (!this.addRoleForm.valid) {
      this.invalidSubmit = true;
      return;
    }

    this.srvDataTable.get('dt_roles').showDetail = false;
    const role = {
      applicationId: this.addRoleForm.value['type'],
      roleName: this.addRoleForm.value['descr']
    };
    this.onSave.emit(role);
    this.addRoleForm = this.createRoleForm(null);
  }

}




// WEBPACK FOOTER //
// ./src/app/views/administration/rolesApplication/rolesApplicationForm.component.ts